import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/live'] // no redirect whitelist

const hr = ['/']
router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start()
  // set page title
  document.title = getPageTitle(to.meta.title)
  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    const hasMenus = store.getters.menus && store.getters.menus.length > 0
    if (hasMenus) {
      next()
    } else {
      try {
        const loginInfo = await store.dispatch('user/getInfo')
        const accessRoutes = await store.dispatch('router-permission/generateRoutes', loginInfo)
        router.addRoutes(accessRoutes)
        next({ ...to, replace: true })
      } catch (error) {
        await store.dispatch('user/resetToken')
        Vue.prototype.alert('获取登录信息失败，请稍后再试')
        NProgress.done()
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1|| to.path.startsWith('/hr/') || hr.indexOf(to.path)!==-1) {
      next()
    } else {
      const code = Vue.prototype.Utils.getQueryObject().code
      const agent_id = Vue.prototype.CONST.AGENT_MAP[to.path]
      if (code && agent_id) {
        // await store.dispatch('user/login', { cx_user: Vue.prototype.CONST.CX_USER, username: '春雪-苏宁', password: 'cx2018tech' })
        // await store.dispatch('user/login', { cx_user: Vue.prototype.CONST.CX_USER, username: '信息-李宁', password: 'cx2018tech' })
        // await store.dispatch('user/login', { cx_user: Vue.prototype.CONST.CX_USER, username: '信息-董雨濛', password: 'cx2018tech' })
        await store.dispatch('user/wxLogin', { code: code, agent_id: agent_id })
          .then(async() => {
            await store.dispatch('user/getInfo').then(() => {
              next()
            }).catch(() => {
              Vue.prototype.alert('获取登录信息失败，请稍后再试')
              NProgress.done()
            })
          })
          .catch(() => {
            Vue.prototype.alert('验证身份失败，请您从企业微信端进入')
            NProgress.done()
          })
      } else {
        Vue.prototype.alert('您的身份为空，请您从企业微信端进入')
        NProgress.done()
      }
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/router-permission.js